var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contract-follow-info" },
    [
      _c("h3", [_vm._v("合同跟进信息")]),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "20px", "text-align": "right" } },
        [
          _vm.editable && _vm.$parent.checkPer(["admin", "contracts:followAdd"])
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.openAddFollowDialog },
                },
                [_vm._v("添加跟进记录")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.followList.length > 0
        ? _c(
            "div",
            [
              _c(
                "el-timeline",
                _vm._l(_vm.followList, function (follow, index) {
                  return _c(
                    "el-timeline-item",
                    {
                      key: index,
                      attrs: {
                        timestamp: follow.createTime,
                        type: "primary",
                        placement: "top",
                      },
                    },
                    [
                      _c("el-card", [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                              "align-items": "flex-start",
                            },
                          },
                          [_c("h4", [_vm._v(_vm._s(follow.content))])]
                        ),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("跟进人：")]),
                          _vm._v(_vm._s(follow.createBy)),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("时间：")]),
                          _vm._v(_vm._s(follow.createTime)),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("通话时长：")]),
                          _vm._v(_vm._s(follow.callDuration || "无")),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("跟进类型：")]),
                          _vm._v(_vm._s(follow.type)),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("步骤：")]),
                          _vm._v(_vm._s(follow.step || "无")),
                        ]),
                        _vm._v(" "),
                        follow.remark
                          ? _c("p", [
                              _c("strong", [_vm._v("备注：")]),
                              _vm._v(_vm._s(follow.remark)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        follow.image || follow.file
                          ? _c("div", [
                              _c("p", [_c("strong", [_vm._v("附件：")])]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "file-list" },
                                [
                                  follow.image
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "file-item",
                                            staticStyle: {
                                              float: "left",
                                              "margin-right": "10px",
                                              "text-align": "center",
                                              position: "relative",
                                            },
                                          },
                                          [
                                            _c("el-image", {
                                              staticStyle: {
                                                width: "100px",
                                                height: "100px",
                                              },
                                              attrs: {
                                                src: follow.image,
                                                "preview-src-list": [
                                                  follow.image,
                                                ],
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  follow.file
                                    ? _vm._l(
                                        _vm.parseFollowFile(follow.file),
                                        function (file, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "file-item",
                                              staticStyle: {
                                                float: "left",
                                                "margin-right": "10px",
                                                "text-align": "center",
                                                position: "relative",
                                              },
                                              style: {
                                                cursor:
                                                  file.type !== "图片"
                                                    ? "pointer"
                                                    : "default",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  file.type !== "图片"
                                                    ? _vm.downloadFile(file.url)
                                                    : null
                                                },
                                              },
                                            },
                                            [
                                              file.type === "图片"
                                                ? [
                                                    _c("el-image", {
                                                      staticStyle: {
                                                        width: "100px",
                                                        height: "100px",
                                                        "border-radius": "5px",
                                                      },
                                                      attrs: {
                                                        src: file.url,
                                                        "preview-src-list": [
                                                          file.url,
                                                        ],
                                                      },
                                                    }),
                                                  ]
                                                : [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          height: "100px",
                                                          width: "100px",
                                                          "border-radius":
                                                            "5px",
                                                          "background-color":
                                                            "#f5f7fa",
                                                          display: "flex",
                                                          "align-items":
                                                            "center",
                                                          "justify-content":
                                                            "center",
                                                          border:
                                                            "1px solid #ebeef5",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "text-align":
                                                                "center",
                                                              padding: "10px",
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-document",
                                                              staticStyle: {
                                                                "font-size":
                                                                  "32px",
                                                                color:
                                                                  "#909399",
                                                                "margin-bottom":
                                                                  "5px",
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "word-break":
                                                                    "break-all",
                                                                  "max-width":
                                                                    "80px",
                                                                  "font-size":
                                                                    "12px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    file.realName
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                            ],
                                            2
                                          )
                                        }
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "no-data" },
            [_c("el-empty", { attrs: { description: "暂无跟进记录" } })],
            1
          ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.isEditMode ? "编辑跟进记录" : "添加跟进记录",
            visible: _vm.showFollowDialog,
            width: "600px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showFollowDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.followForm, "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "跟进人" } },
                [
                  _vm._l(_vm.followUserList, function (item) {
                    return _c(
                      "el-tag",
                      { staticStyle: { "margin-right": "2px" } },
                      [_vm._v(_vm._s(item))]
                    )
                  }),
                  _vm._v(" "),
                  _c("el-button", {
                    attrs: { icon: "el-icon-plus" },
                    on: {
                      click: function ($event) {
                        return _vm.onUserSelect("跟进人")
                      },
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "跟进内容" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: "4",
                      placeholder: "请输入跟进内容",
                    },
                    model: {
                      value: _vm.followForm.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.followForm, "content", $$v)
                      },
                      expression: "followForm.content",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "跟进类型" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入跟进类型" },
                    model: {
                      value: _vm.followForm.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.followForm, "type", $$v)
                      },
                      expression: "followForm.type",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "通话时长" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入通话时长（分钟）" },
                    model: {
                      value: _vm.followForm.callDuration,
                      callback: function ($$v) {
                        _vm.$set(_vm.followForm, "callDuration", $$v)
                      },
                      expression: "followForm.callDuration",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "步骤" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入跟进步骤" },
                    model: {
                      value: _vm.followForm.step,
                      callback: function ($$v) {
                        _vm.$set(_vm.followForm, "step", $$v)
                      },
                      expression: "followForm.step",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "附件" } }, [
                _c(
                  "div",
                  [
                    _c("common-upload", {
                      ref: "followFileUpload",
                      on: {
                        uploadSuccess: _vm.handleFollowFileUpload,
                        delSuccess: _vm.handleFollowFileDelete,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.followAttachments && _vm.followAttachments.length > 0
                  ? _c(
                      "div",
                      { staticClass: "demo-image__preview" },
                      _vm._l(_vm.followAttachments, function (file, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticStyle: {
                              float: "left",
                              "margin-right": "10px",
                              "text-align": "center",
                              position: "relative",
                            },
                            style: {
                              cursor:
                                file.type !== "图片" ? "pointer" : "default",
                            },
                            on: {
                              click: function ($event) {
                                file.type !== "图片"
                                  ? _vm.downloadFile(file.url)
                                  : null
                              },
                            },
                          },
                          [
                            file.type === "图片"
                              ? [
                                  _c("el-image", {
                                    staticStyle: {
                                      "margin-top": "20px",
                                      height: "147px",
                                      width: "147px",
                                      "border-radius": "5px",
                                    },
                                    attrs: {
                                      src: file.url,
                                      "preview-src-list": [file.url],
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "el-upload-list__item-delete",
                                      staticStyle: {
                                        position: "absolute",
                                        top: "20px",
                                        right: "0",
                                        "z-index": "9999",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.delFollowAttachmentByIndex(
                                            index
                                          )
                                        },
                                      },
                                    },
                                    [_c("i", { staticClass: "el-icon-delete" })]
                                  ),
                                ]
                              : [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "margin-top": "20px",
                                        height: "147px",
                                        width: "147px",
                                        "border-radius": "5px",
                                        "background-color": "#f5f7fa",
                                        display: "flex",
                                        "align-items": "center",
                                        "justify-content": "center",
                                        border: "1px solid #ebeef5",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "text-align": "center",
                                            padding: "10px",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-document",
                                            staticStyle: {
                                              "font-size": "48px",
                                              color: "#909399",
                                              "margin-bottom": "10px",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "word-break": "break-all",
                                                "max-width": "120px",
                                                "font-size": "12px",
                                              },
                                            },
                                            [_vm._v(_vm._s(file.realName))]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "el-upload-list__item-delete",
                                      staticStyle: {
                                        position: "absolute",
                                        top: "20px",
                                        right: "0",
                                        "z-index": "9999",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.delFollowAttachmentByIndex(
                                            index
                                          )
                                        },
                                      },
                                    },
                                    [_c("i", { staticClass: "el-icon-delete" })]
                                  ),
                                ],
                          ],
                          2
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: "2",
                      placeholder: "请输入备注",
                    },
                    model: {
                      value: _vm.followForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.followForm, "remark", $$v)
                      },
                      expression: "followForm.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showFollowDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveFollow } },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("UserSelect", {
        ref: "userSelect",
        attrs: { "show-user-select": _vm.showUserSelect },
        on: {
          close: _vm.onUserSelectClose,
          "select-user-callBack": _vm.selectUserCallBack,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }